var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.alias=='platform')?_c('platform'):_c('other',{attrs:{"alias":_vm.alias}}),_c('home-try',{attrs:{"alias":_vm.alias}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }